<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productRecipe.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productRecipe.pageTitle'),
            href: '/admin/product-add-on',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-4 form-group">
              <div class="row">
                <div class="col-12 form-group">
                  <label>{{ $t('productRecipe.productType') }}</label>
                  <select
                    v-model="productTypeId"
                    class="form-control"
                    @change="onProductTypeChange"
                  >
                    <option :value="1">Assembly</option>
                    <option :value="2">Non-Assembly</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-12 form-group">
                  <label class="required">{{
                    $t('productRecipe.product')
                  }}</label>
                  <a-select
                    v-model="model.product_id"
                    @change="onProductChange"
                    class="ts-w-full"
                    :options="productOption"
                    showSearch
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                  ></a-select>
                  <div class="validate" v-if="errors.has('product_id')">
                    {{ errors.first('product_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label>
                    {{ $t('productRecipe.applyToOtherProduct') }}
                  </label>
                  <div
                    class="
                      ts-border
                      ts-border-gray-400
                      ts-rounded-sm
                      ts-p-3
                      ts-relative
                    "
                  >
                    <span
                      class="
                        ts-ml-3
                        ts-bg-green-500
                        ts-text-white
                        ts-px-3
                        ts-py-2
                        ts-rounded-full
                        ts-absolute
                        ts-top-0
                        ts-right-0
                        ts--mt-3
                        ts--mr-3
                        ts-font-bold
                        ts-cursor-pointer
                      "
                      @click.prevent="() => (show_product_apply_add_on = true)"
                    >
                      <i class="fa fa-plus"></i>
                    </span>
                    <br />
                    <div class="max-h">
                      <p
                        class="
                          ts-border-blue-500
                          ts-border
                          ts-py-1
                          ts-px-3
                          ts-text-blue-500
                          ts-font-hanuman
                          ts-rounded
                          ts-relative
                        "
                        v-for="(id, index) in model.apply_to_other_product_id"
                        :key="index"
                      >
                        {{ getDisplayProductName(id) }}
                        <span
                          class="
                            ts-bg-red-500
                            ts-absolute
                            ts-right-0
                            ts-text-white
                            ts-mr-2
                            ts-px-1
                            ts-cursor-pointer
                          "
                          v-tooltip="$t('delete')"
                          @click="removeProductApplyAddOn(index)"
                          >x</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 form-group">
              <RecipeList
                v-model="model"
                :list="recipeList"
                class="ts-border ts-border-gray-300 ts-rounded ts-p-3"
              />
              <div class="validate" v-if="errors.has('sale_code_id_list')">
                {{ errors.first('sale_code_id_list') }}
              </div>
            </div>
            <div class="col-md-4 form-group">
              <SelectedRecipeList
                v-model="model"
                :list="recipeList"
                class="ts-border ts-border-gray-300 ts-rounded ts-p-3"
              />
            </div>
          </div>
          <div class="row">
            <div
              class="
                col-md-12
                ts-flex ts-items-center ts-space-x-3 ts-justify-end
              "
            >
              <ts-button
                @click.prevent="$router.push({ name: 'product-add-on' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                color="primary"
                outline
                :waiting="waiting_new"
                @click.prevent="onSaveAddNew"
                >{{ $t('save_add_new') }}</ts-button
              >
              <ts-button
                :waiting="waiting"
                @click.prevent="onSave"
                color="primary"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
        <a-modal
          v-model="show_product_apply_add_on"
          :title="$t('productRecipe.product')"
          :footer="null"
          centered
          :maskClosable="false"
          :zIndex="1020"
        >
          <input
            v-model="text_search"
            :placeholder="$t('search')"
            type="text"
            class="form-control"
          />
          <div class="max-h ts-mt-3 ts-space-y-1 ts-p-3">
            <p
              class="
                ts-border-blue-500
                ts-border
                ts-py-1
                ts-px-3
                ts-text-blue-500
                ts-font-hanuman
                ts-rounded
                ts-relative
              "
              v-for="(product, index) in productListExclude"
              :key="index"
            >
              {{
                product.group.pro_group_name_en + '-' + product.product_name_en
              }}
              <span
                class="ts-absolute ts-right-0 ts-mr-2 ts-px-1 ts-cursor-pointer"
                v-tooltip="$t('add')"
                @click.prevent="addProductApplyAddOn(product)"
                ><i class="fa fa-plus"></i
              ></span>
            </p>
          </div>
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import RecipeList from './component/recipe-list.vue'
import SelectedRecipeList from './component/selected-recipe.vue'

export default {
  name: 'addOnCreate',
  components: {
    RecipeList,
    SelectedRecipeList,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting_new: false,
      waiting: false,
      show_product_apply_add_on: false,
      text_search: '',
      recipeList: [],
      products: [],
      model: {
        product_id: null,
        sale_code_id_list: [],
        apply_to_other_product_id: [],
      },
    }
  },
  computed: {
    productOption() {
      return this.products.map((el) => ({
        value: el.product_id,
        label: el.group.pro_group_name_en + '-' + el.product_name_en,
      }))
    },
    productTypeId: {
      get() {
        return this.$store.state.product.addOn.product_type_id
      },
      set(newValue) {
        this.$store.commit('product/addOn/SET_PRODUCT_TYPE_ID', newValue)
      },
    },
    productListExclude: (vm) => {
      return vm.products
        .filter(
          (p) => !_.includes(vm.model.apply_to_other_product_id, p.product_id)
        )
        .filter((p) =>
          vm.text_search
            .toLowerCase()
            .split(' ')
            .every((t) =>
              (p.group.pro_group_name_en + '-' + p.product_name_en)
                .toLowerCase()
                .includes(t)
            )
        )
      // .filter(p => vm.text_search.toLowerCase().split(' ').every(t => .toLowerCase().includes(t)))
    },
  },
  created() {
    this.model.product_id = parseInt(this.$route.params.id)
  },
  methods: {
    ...mapActions('product/addOn', [
      'getRecipe',
      'getProduct',
      'findProduct',
      'store',
    ]),
    async fetchData() {
      this.loading = true
      this.$store.commit(
        'product/addOn/SET_PRODUCT_TYPE_ID',
        parseInt(this.$route.query.product_type_id)
      )
      let recipe = await this.getRecipe()
      this.recipeList = recipe.data
      let product = await this.getProduct()
      this.products = product.data
      await this.find()
      this.loading = false
    },
    removeProductApplyAddOn(index) {
      this.model.apply_to_other_product_id.splice(index, 1)
    },
    getDisplayProductName(productId) {
      let product = this.products.find((p) => p.product_id == productId)
      return product.group.pro_group_name_en + '-' + product.product_name_en
    },
    addProductApplyAddOn(product) {
      this.model.apply_to_other_product_id.push(product.product_id)
    },
    onProductChange() {
      this.$router.replace({
        name: 'product-add-on-create',
        params: {
          id: this.model.product_id,
        },
        query: {
          product_type_id: this.productTypeId,
        },
      })
			this.find()
    },
    onProductTypeChange() {
      this.$router.replace({
        name: 'product-add-on-create',
        params: {
          id: 0,
        },
        query: {
          product_type_id: this.productTypeId,
        },
      })
			this.fetchData()
    },
    async find() {
			this.loading = true
      let response = await this.findProduct(this.$route.params.id)
      this.model.apply_to_other_product_id = []
			if(response.data.length){
				this.model.sale_code_id_list = response.data[0].product_add_on.map(
					(el) => el.addon_pro_sale_code_id
				)
			}
			this.loading = false
    },
    onSave() {
      this.waiting = true
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product-add-on' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.waiting_new = true
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
			this.model.product_id = null
      this.model.sale_code_id_list = []
      this.model.apply_to_other_product_id = []
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/addOn/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData()
    })
  },
}
</script>

<style scoped>
.max-h {
  min-height: 400px;
  max-height: 450px;
  overflow: scroll;
}
</style>